import { GeneralSetting, PortalEntity, PortalEntityResponse, PortalLoginRequest, PortalLoginResponse } from '@jms/model';
import { ApplicationActionName } from './application.model';
import { createAction, props } from '@ngrx/store';

export const authenticateLoginUserAction = createAction(
    ApplicationActionName.AuthenticateLoginUser,
    props<{ request: PortalLoginRequest }>()
);

export const authenticateLoginUserErrorAction = createAction(
    ApplicationActionName.AuthenticateLoginUserError,
    props<{ error: any }>()
);

export const handleValidUserAction = createAction(
    ApplicationActionName.HandleValidUser,
    props<{ response: PortalLoginResponse }>()
);

export const handleInvalidUserAction = createAction(
    ApplicationActionName.HandleInvalidUser,
    props<{ url: string }>()
);

export const logoutAction = createAction(
    ApplicationActionName.LogOut
);

export const getPortalEntitiesAction = createAction(
    ApplicationActionName.GetPortalEntities
);

export const getPortalEntitiesSuccessAction = createAction(
    ApplicationActionName.GetPortalEntitiesSuccess,
    props<{ response: PortalEntityResponse[] }>()
);

export const getPortalEntitiesFailAction = createAction(
    ApplicationActionName.GetPortalEntitiesFail,
    props<{ error: any }>()
);

export const changePortalEntityAction = createAction(
    ApplicationActionName.ChangePortalEntity,
    props<{ entity: PortalEntity }>()
);